import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import Routing, { SideMenu } from '../../components/reusable/routing'

import { useReports, useLatestPathname } from '../../modules'

import TraumaQueue from './Queue.js'

let menu = [
    {
        path: 'queue',
        title: 'Queue',
        component: TraumaQueue
    }
]

const Trauma = () => {
    const history = useHistory()
    const { user } = useSelector(state => state.application)
    const pathname = useLatestPathname()

    const [Reports, reports] = useReports("trauma")

    useEffect(() => {
        menu[1] = {
            path: 'reports',
            title: 'Reports',
            component: () => <Reports reports={ reports } department="trauma" />
        }

        const target = `/app/trauma/${menu[0].path}`
        if (!pathname.current.startsWith(target)) history.push(target)
    }, [user, reports])

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto flex flex-no-wrap max-h-full overflow-hidden">
            <div className="w-1/6 overflow-y-scroll">
                <p className="text-2xl font-semibold">Trauma</p>
                <SideMenu namespace="trauma" menu={ menu } />
            </div>
            <div className="w-5/6 overflow-y-scroll">
                <Routing namespace="trauma" menu={ menu } />
            </div>
        </div>
    )
}

export default Trauma